/* eslint-disable */
import React, { useState, useMemo, useEffect } from "react";
import "../../../../../../styles/Pages/Organizational/Management/Activities/Messaging.style.css";
import { ReactComponent as MessagingArrowIcon } from "../../../../../../assets/Icons/Pages/Organizational/Management/Activities/MessagingArrow.svg";
import MessagingUserCard from "./MessagingUserCard.component";
import ActivityMessaging from "../../../../../../store/ActivityMessaging.store";
import MessagingHistory from "./MessagingHistory.component";
const rolesColors = [
  "#7BD7CD",
  "#91B9FA",
  "#A7A9F7",
  "#F9C876",
  "#ADB86B",
  "#A7A9F7",
];
const MessagingFloatingCard = ({isMessageOpen}) => {
  const [isOpenMessagingCard, setIsOpenMessagingCard] = useState();
  const { messagingId, setMessageId } = ActivityMessaging();
  const [profileData, setProfileData] = useState(null);
  useEffect(() => {
    setIsOpenMessagingCard(isMessageOpen);
  }, [isMessageOpen]);
  const setMessingId = (_e, _id, color, title) => {
    setProfileData({ _id, color, title });
    setMessageId(_id);
  };
  // Memoized MessagingUserCard list
  const userCards = useMemo(() => {
    return (
      <>
        <MessagingUserCard
          _id="1"
          title="All Teachers"
          handelClick={setMessingId}
          color={rolesColors[Math.floor(Math.random() * 6)]}
        />
        <MessagingUserCard
          _id="2"
          title="Math Teachers"
          handelClick={setMessingId}
          color={rolesColors[Math.floor(Math.random() * 6)]}
        />
        <MessagingUserCard
          _id="3"
          title="Science Teachers"
          handelClick={setMessingId}
          color={rolesColors[Math.floor(Math.random() * 6)]}
        />
        <MessagingUserCard
          _id="4"
          title="History Teachers"
          handelClick={setMessingId}
          color={rolesColors[Math.floor(Math.random() * 6)]}
        />
      </>
    );
  }, []);

  return (
    <div
      className="messagingFloatingCard"
      style={{ top: isOpenMessagingCard ? "40vh" : "98vh" }}
    >
      <div className="messageCardOpenSection">
        <button onClick={() => setIsOpenMessagingCard(!isOpenMessagingCard)}>
          <MessagingArrowIcon
            className="messagingOpeningIcon"
            style={{
              transform: isOpenMessagingCard
                ? "rotate(0deg)"
                : "rotate(-180deg)",
            }}
          />
        </button>
      </div>
      <div className="messagingFloatingCardRapper h-full w-full">
        {messagingId !== "" && (
          <MessagingHistory
            data={profileData && profileData}
            setProfileData={setProfileData}
          />
        )}
        <div
          className="messageBody scroll-y flex-col align-start justify-start g-05"
          style={{ height: isOpenMessagingCard ? "100%" : "0" }}
        >
          {isOpenMessagingCard && messagingId === "" && userCards}
        </div>
      </div>
    </div>
  );
};

export default MessagingFloatingCard;
